
import { User } from '@/lib/types';

// Convert Supabase User to our app User type
export const convertSupabaseUser = (supabaseUser: any): User | null => {
  if (!supabaseUser) return null;
  
  return {
    id: supabaseUser.id,
    email: supabaseUser.email || '',
    name: supabaseUser.user_metadata?.name || '',
    createdAt: new Date(supabaseUser.created_at),
  };
};
